import React from 'react'

type AdministrationConfigContextData = {
  userPermissions: string []
}
export const AdministrationConfigContext = React.createContext<AdministrationConfigContextData>({
  userPermissions: []
})